import React from 'react';
import api from "./../../../services/api";
//import { NavLink } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import './../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css';
import GetAgent from './GetAgent';
import { user_token } from '../../../services/Auth';
import "./style.css";
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav_PS';
import GetUser from './GetUser';
import FormsEdit from './FormsEdit';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class FormsAgendamento extends React.Component {

    state = {
        exames: [],
        alcoholism: '',
        smoking: '',
        activity: '',
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {
        const { id } = this.props.match.params;
        console.log(id);
        const request = await apiProfessional.getExam(id);
        console.log(request);
        console.log(request.data);
        this.life_habits( request.data )
        this.setState({ exames: request.data });
    
    };

    life_habits(exams){
      let alc, smo, act;
      const teste = exams.map(function(item){
        return item;
      });
      alc = teste[0]['monitoration_record']['life_habits']['alcoholism'];
      if(alc === "False"){
        this.setState({alcoholism : "Não"})
      }else{
        this.setState({alcoholism : "Sim"})
      }

      smo = teste[0]['monitoration_record']['life_habits']['smoking'];
      if(smo === "False"){
        this.setState({smoking : "Não"})
      }else{
        this.setState({smoking : "Sim"})
      }

      act = teste[0]['monitoration_record']['life_habits']['physical_activity'];
      if(act === "False"){
        this.setState({activity : "Não"})
      }else{
        this.setState({activity : "Sim"})
      }
    };

    render() {
        return (
          <>
          <SideNav />
          <div id="top-PS">
            <Grid container spacing={0} direction="row" justify="left" alignItems="center" style={{ marginTop: '-35vh' }}>
              <Grid item xs={2} sm={2} md={1} lg={1} align="center">

              </Grid>
              <Grid item xs={8} sm={8} md={10} lg={10}></Grid>
              <Grid item xs={2} sm={2} md={1} lg={1} align="center">
              </Grid>
            </Grid>
          </div>
            
          {/* <Grid container spacing={0} direction="row" justify="left" alignItems="center">
            <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
            <Grid item xs={12} sm={12} md={10} lg={6} align="center">
              <div id="main-RI-Consulta-Pendente">
                <h1 id="title">Consulta Passada</h1>
                <br></br>

                <h1 id="tittle-forms-cme">Informações da Consulta</h1>
                <hr id="coloring_line"/>     
                <br></br>
                <hr id="line-dashed-separator"></hr>
                <h3 id="specific-tittle-small">Dados do pedido da Consulta</h3>           
                <p id="RI-Title-Cadastro-Paciente">Finalidade de Atendimento:</p><p>{details.appointment_type}</p>
                <p id="RI-Title-Cadastro-Paciente">Especialidade: </p><p>{details.medical_appointment_type}</p>
                <p id="RI-Title-Cadastro-Paciente">Proposta: </p><p>{details.appointment_purpose}</p>
                <p id="RI-Title-Cadastro-Paciente">Turno de atendimento: </p><p>{details.appointment_period}</p>
                <p id="RI-Title-Cadastro-Paciente">Data/Hora:</p><p>{details.date}</p>
                <hr id="line-dashed-separator"></hr>

                <h3 id="specific-tittle-small">Prontuário de Monitoramento da Consulta</h3>
                <p id="RI-Title-Cadastro-Paciente">Anamnsese: </p><p>{details.monitoration_record.anamnese}</p>
                <p id="RI-Title-Cadastro-Paciente">Conduta: </p><p>{details.monitoration_record.conduct}</p>
                <p id="RI-Title-Cadastro-Paciente">Diagnóstico: </p><p>{details.monitoration_record.diagnosis}</p>
                <p id="RI-Title-Cadastro-Paciente">Medicamentos em uso: </p><p>{details.monitoration_record.medications_in_use}</p>
                <p id="RI-Title-Cadastro-Paciente">Referência: </p><p>{details.monitoration_record.referrals}</p>
                <p id="RI-Title-Cadastro-Paciente">Histórico de cirurgia: </p><p>{details.monitoration_record.life_habits.surgery}</p>
                <p id="RI-Title-Cadastro-Paciente">Atividade de Física: </p><p>{this.state.activity}</p>
                <p id="RI-Title-Cadastro-Paciente">Álcoolismo: </p><p>{this.state.alcoholism}</p>
                <p id="RI-Title-Cadastro-Paciente">Quantidade: </p><p>{details.monitoration_record.life_habits.alcoholism_amount}</p>
                <p id="RI-Title-Cadastro-Paciente">Tabagismo: </p><p>{this.state.smoking}</p>
                <p id="RI-Title-Cadastro-Paciente">Quantidade: </p><p>{details.monitoration_record.life_habits.smoking_amount}</p>
                <hr id="line-dashed-separator"></hr>              
                
                <h3 id="specific-tittle-small">Prescrição feita pelo profissional da saúde</h3>
                <p id="RI-Title-Cadastro-Paciente">Prescrição:</p><p>{details.prescription}</p>
                <p id="RI-Title-Cadastro-Paciente">Notas da consulta:</p><p>{details.medical_note}</p>
                <hr id="line-dashed-separator"></hr>
                <br></br>
                <hr id="coloring_line"/>  
                <br></br> */}



                <div id="lista-style">
                  {this.state.exames.map(details => (
                    <>
                      <div id="exam">

                        <h1 id="tittle-forms-cme">Informações da Instituição</h1>
                        <hr id="coloring_line" />
                        <GetAgent agent_id={details.agent_id} />
                        <hr id="coloring_line" />
                        <br></br>

                        <h1 id="tittle-forms-cme">Informações da Consulta</h1>
                        <hr id="coloring_line" />
                        <br></br>
                        <hr id="line-dashed-separator"></hr>
                        <h3 id="specific-tittle-small">Dados do pedido da Consulta</h3>
                        <p id="RI-Title-Cadastro-Paciente">Finalidade de Atendimento:</p><p>{details.appointment_type}</p>
                        <p id="RI-Title-Cadastro-Paciente">Especialidade: </p><p>{details.medical_appointment_type}</p>
                        <p id="RI-Title-Cadastro-Paciente">Proposta: </p><p>{details.appointment_purpose}</p>
                        <p id="RI-Title-Cadastro-Paciente">Turno de atendimento: </p><p>{details.appointment_period}</p>
                        <p id="RI-Title-Cadastro-Paciente">Data/Hora:</p><p>{details.date}</p>
                        <hr id="line-dashed-separator"></hr>

                        <h3 id="specific-tittle-small">Prontuário de Monitoramento da Consulta</h3>
                        <p id="RI-Title-Cadastro-Paciente">Anamnsese: </p><p>{details.monitoration_record.anamnese}</p>
                        <p id="RI-Title-Cadastro-Paciente">Conduta: </p><p>{details.monitoration_record.conduct}</p>
                        <p id="RI-Title-Cadastro-Paciente">Diagnóstico: </p><p>{details.monitoration_record.diagnosis}</p>
                        <p id="RI-Title-Cadastro-Paciente">Medicamentos em uso: </p><p>{details.monitoration_record.medications_in_use}</p>
                        <p id="RI-Title-Cadastro-Paciente">Referência: </p><p>{details.monitoration_record.referrals}</p>
                        <p id="RI-Title-Cadastro-Paciente">Histórico de cirurgia: </p><p>{details.monitoration_record.life_habits.surgery}</p>
                        <p id="RI-Title-Cadastro-Paciente">Atividade de Física: </p><p>{details.monitoration_record.life_habits.physical_activity}</p>
                        <p id="RI-Title-Cadastro-Paciente">Álcoolismo: </p><p>{details.monitoration_record.life_habits.alcoholism}</p>
                        <p id="RI-Title-Cadastro-Paciente">Quantidade: </p><p>{details.monitoration_record.life_habits.alcoholism_amount}</p>
                        <p id="RI-Title-Cadastro-Paciente">Tabagismo: </p><p>{details.monitoration_record.life_habits.smoking}</p>
                        <p id="RI-Title-Cadastro-Paciente">Quantidade: </p><p>{details.monitoration_record.life_habits.smoking}</p>
                        <hr id="line-dashed-separator"></hr>

                        <h3 id="specific-tittle-small">Prescrição feita pelo profissional da saúde</h3>
                        <p id="RI-Title-Cadastro-Paciente">Prescrição:</p><p>{details.prescription}</p>
                        <p id="RI-Title-Cadastro-Paciente">Notas da consulta:</p><p>{details.medical_note}</p>
                        <hr id="line-dashed-separator"></hr>
                        <br></br>
                        <hr id="coloring_line" />
                        <br></br>

                        <h1 id="tittle-forms-cme">Informações do Paciente</h1>
                        <hr id="coloring_line" />
                        <br></br>
                        <hr id="line-dashed-separator"></hr>
                        <h3 id="specific-tittle-small">Dados do Paciente</h3>
                        <GetUser user_id={details.user_id} />
                        <hr id="coloring_line" />
                        <br></br>

                        <FormsEdit exam_id={details._id} />

                      </div>
                      <br></br>
                    </>
                  ))}
                </div>
          </>
      )
    }
}
